"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountRoutes = void 0;
var AccountRoutes;
(function (AccountRoutes) {
    AccountRoutes["BasePrefix"] = "accounts";
    AccountRoutes["ById"] = ":accountId";
    AccountRoutes["AllByClient"] = "all/:clientId";
    AccountRoutes["List"] = "list";
})(AccountRoutes = exports.AccountRoutes || (exports.AccountRoutes = {}));
